import BaseMenuItem, { menuItemClasses } from '@mui/material/MenuItem'
import { TextScale } from 'particles/Text'
import styled from 'particles/themes/styled'
import { getAlignItems } from 'particles/utils'

interface StyledMenuItemProps extends React.ComponentProps<typeof BaseMenuItem> {
    containerHeight?: number
    textScale?: TextScale
}

export const StyledBaseMenuItem = styled(BaseMenuItem)<StyledMenuItemProps>`
    &.${menuItemClasses.root} {
        display: flex;
        font-family: inherit;
        padding: 0;
        border-radius: 4px;
        box-sizing: border-box;
        align-items: ${({ theme, textScale, containerHeight }) => getAlignItems(theme, textScale, containerHeight)};
        gap: ${({ theme }) => theme.spacing[200]};
        &.${menuItemClasses.disabled} {
            opacity: 1;
            .tooltip {
                pointer-events: all;
            }
        }
        &:hover,
        ${`&.${menuItemClasses.focusVisible}`}:hover {
            background-color: ${({ theme, disabled }) =>
                disabled ? 'transparent' : theme.colors.surface.neutralActionSubPastelHover};
        }
        .tooltip {
            padding: 2px 0px;
        }
    }
`
